module.exports = __webpack_public_path__ + "img/icon_logout.350410f1.svg";